export default "__VITE_ASSET__CXdPbZXb__"